import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AlertService } from 'ngx-venus';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class CustodyCryptoService {
  constructor(
    protected http: HttpClient,
    public alertService: AlertService,
  ) {}

  getWalletStatus(walletAddress: string, merchantId: string): Observable<any> {
    const url = `/api/v2/checkout/custodycrypto/deposit/merchant/get/transaction`;
    return this.http.post<any>(url, { walletAddress, merchantId }).pipe(
      map((response) => {
        if (response) {
          return response.data?.status || response.status;
        } else {
          throw new HttpErrorResponse({
            error: response,
            url,
          });
        }
      }),
    );
  }
}
